import { type ReactNode } from "react";

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex">
      {/* Left side - branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 p-12 flex-col justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img
            src="/logo.jpg"
            alt="G-Wiz"
            className="w-10 h-10 rounded-xl object-cover"
          />
          <span className="font-display font-bold text-2xl text-white">
            G-Wiz | PQ
          </span>
        </div>

        {/* Feature highlights */}
        <div className="space-y-8">
          <h1 className="font-display text-4xl font-bold text-white leading-tight">
            G-Wiz
            <br />
            PQ Edition
          </h1>
          <p className="text-blue-100 text-lg max-w-md">
            ระบบติดตามการจัดซื้อจัดจ้างภาครัฐสำหรับ
            <br />
            บริษัท เพรสควอลิตี้ จำกัด
          </p>
        </div>

        {/* Footer */}
        <p className="text-blue-200 text-sm">
          © {new Date().getFullYear()} Press Quality Company Limited.
        </p>
      </div>

      {/* Right side - auth form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden flex items-center justify-center gap-3 mb-8">
            <img
              src="/logo.jpg"
              alt="G-Wiz"
              className="w-10 h-10 rounded-xl object-cover"
            />
            <span className="font-display font-bold text-2xl text-slate-900">
              G-Wiz | PQ
            </span>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}
